<style scoped>
    /*div .row{
        margin-top:10px;
        height:auto
    }*/
</style>
<template>
    <div v-if="controller">
        <div class="row" v-if="!controller.IsUpdating_Dosage">
            <div class="col-md-6">
                <div v-if="controller.IsNew">
                    <div class="form-group" v-bind:class="{ 'has-error' : controller.drug.hasError,'has-warning' : controller.drug.hasWarning ,'has-success' : controller.drug.hasSuccess}" style="height:100%">
                        <label class="control-label" for="focusedInput">{{controller.drug.name}}</label>
                        <DrugSearchSelector v-model="controller.drug" style="height:auto"></DrugSearchSelector>
                        <span class="help-block" v-if="controller.drug.hasWarning || controller.drug.hasError" style="margin-top:10px">
                            <i class="fa" v-bind:class="{ 'fa-exclamation-circle' : controller.drug.hasError,'fa-exclamation-triangle' : controller.drug.hasWarning }"></i>
                            <small>{{controller.drug.message}}</small>
                        </span>
                    </div>
                </div>
                <div v-else>
                    <div class="form-group" style="height:100%">
                        <label class="control-label">Drug</label>
                        <input class="form-control" v-model="controller.drug.value.searchText" disabled />
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <!--<span v-if="!controller.IsNew">
        <label>Start Date</label>
        <input class="form-control" readonly :value="FormatDate(controller.startDate.value)" />
    </span>
    <span v-if="controller.IsNew" >
        <datepicker :controller="controller.startDate" :start-date="today" :end-date="controller.cycle.endDate"></datepicker>
    </span>-->
                <datepicker :controller="controller.startDate" :start-date="controller.startDate.Value" :end-date="controller.cycle.endDate"></datepicker>
            </div>
            <div class="col-md-3">
                <datepicker :controller="controller.endDate" :start-date="today" :end-date="controller.cycle.endDate"></datepicker>
            </div>
        </div>


        <div class="row">


            <div class="col-md-3">
                <forminput v-bind:controller="controller.quantity"></forminput>
            </div>
            <div class="col-md-3">
                <forminput v-bind:controller="controller.unitOfMeasure"></forminput>
            </div>

            <div class="col-md-6">
                <forminput v-bind:controller="controller.notes"></forminput>
            </div>

        </div>
        <div class="row">
            <br />
            <div class="col-md-2">
                <formcheckbox :controller="controller.isInsulin"></formcheckbox>
            </div>
            <div class="col-md-2">
                <formcheckbox :controller="controller.showInEMAR "></formcheckbox>
            </div>
            <div class="col-md-2">
                <formcheckbox :controller="controller.treatAsCD"></formcheckbox>
            </div>
            <div class="col-md-2">
                <formcheckbox :controller="controller.useBodyMap"></formcheckbox>
            </div>
        </div>
    </div>
</template>
<script>

    import DrugSearchSelector from "../DrugSearchSelector/DrugSearchSelector.scp.html"
    import forminput from "../../corecontrols/forminput/forminput.scp.html"
    import formcheckbox from "../../corecontrols/formcheckbox/formcheckbox.scp.html"
    import datepicker from "../../corecontrols/datepicker/datepicker.scp.html"
    import ScheduleSelector from "../ScheduleSelector/ScheduleSelector.scp.html";
    import RoundSelector from "../RoundSelector/RoundSelector.scp.html";
    import moment from 'moment'
    import Formatter from "../../corecontrols/formatters/Formatter";


    export default {
        props: ['controller', 'mode'],
        data: function () {
            return {
                today: moment(new Date()).subtract(1, 'days').toDate()
            }
        },
        methods: {
            FormatDate: (d) => Formatter.FormatDate(d)
        },
        components: {
            DrugSearchSelector,
            forminput,
            ScheduleSelector,
            RoundSelector,
            datepicker,
            formcheckbox,
            //WorkerButton
        }
    }

    //export default {
    //    props: ['mode','patient', 'cycle', 'dispensationItem', 'ward'],
    //    data: function () {
    //        return {
    //            controller: undefined
    //        }
    //    },
    //    watch: {
    //        ward() {
    //            if (this.ward && this.ward.wardRounds) {
    //                var dispensationItem = this.dispensationItem ? this.dispensationItem : null;
    //                this.controller = new MedProfileEditorController(this.cycle, this.patient, this.ward, dispensationItem);
    //            }
    //        }
    //    },
    //    mounted() {
    //        var dispensationItem = this.dispensationItem ? this.dispensationItem : null;
    //        if (this.ward && this.ward.wardRounds) {
    //            this.controller = new MedProfileEditorController(this.cycle, this.patient, this.ward, dispensationItem);
    //        }
    //    },
    //    components: {
    //        DrugSearchSelector,
    //        forminput,
    //        ScheduleSelector,
    //        RoundSelector,
    //        datepicker,
    //        formcheckbox
    //    }
    //}
</script>



// WEBPACK FOOTER //
// DispensationItemBasicEditor.scp.html?08149057